"use strict";
Object.defineProperty(exports, "__esModule", { value: true });



//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/duc/components/atoms/Spinner/SpinnerProps.js
// module id = 1650
// module chunks = 8